export const USER_ROLES = {
  SUPER_USER: "Super",
  MD_USER: "MD",

  ADMIN_USER: "Admin",
  HR_USER: "HR",

  EXECUTIVE_USER: "Executive", //feedback drawer url not working
  GENERAL_MANAGER: "General Manager", //feedback drawer url not working
  MANAGER_USER: "Manager", //feedback drawer url not working

  EMPLOYEE_USER: "Employee", //feedback drawer url not working
  GUEST_USER: "Guest", //Execution drawer url not working, Does not have feedback, Portfolio of Evidence
  BOARD_MEMBER_USER: "Board", //feedback drawer url not working
};

export const userRolesAccessRights = (role: string) => {};
